import { apiAuth, apiResponseType } from ".";

export interface SedexSaleStatus {
  id: number;
  name: string;
}

export interface SedexSaleFiltersParams {
  sedex_status_id?: string[];
  seller_id?: string[];
  unity_id?: string;
  sale_id?: string;
  client_name?: string;
  tracking_code?: string;
  start_date?: string;
  end_date?: string;
  order_by?: string;
  order_direction?: string;
  per_page?: number;
  only_edited?: boolean;
}

export interface UpdateSedexStatusParams {
  sedex_status_id?: number;
  tracking_code?: string;
  expected_arrival_date?: string;
}

export interface PrintLabelData {
  sale_id: number;
  client_name: string;
  address: {
    street?: string;
    number?: string;
    complement?: string;
    neighborhood?: string;
    city?: string;
    state?: string;
    zip_code?: string;
  } | null;
  tracking_code: string | null;
}

export const getSedexSales = (page: number = 1, params?: SedexSaleFiltersParams) => {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page.toString());

  if (params?.sedex_status_id && params.sedex_status_id.length > 0) {
    params.sedex_status_id.forEach(id => {
      queryParams.append("sedex_status_id[]", id);
    });
  }
  if (params?.seller_id && params.seller_id.length > 0) {
    params.seller_id.forEach(id => {
      queryParams.append("seller_id[]", id);
    });
  }
  if (params?.unity_id && params.unity_id !== "all")
    queryParams.append("unity_id", params.unity_id);
  if (params?.sale_id)
    queryParams.append("sale_id", params.sale_id);
  if (params?.client_name)
    queryParams.append("client_name", params.client_name);
  if (params?.tracking_code)
    queryParams.append("tracking_code", params.tracking_code);
  if (params?.start_date)
    queryParams.append("start_date", params.start_date);
  if (params?.end_date)
    queryParams.append("end_date", params.end_date);
  if (params?.order_by)
    queryParams.append("order_by", params.order_by);
  if (params?.order_direction)
    queryParams.append("order_direction", params.order_direction);
  if (params?.per_page)
    queryParams.append("per_page", params.per_page.toString());
  if (params?.only_edited)
    queryParams.append("only_edited", "true");

  return apiAuth.get(`/sedex-sales?${queryParams.toString()}`) as apiResponseType;
};

export const getSedexStatuses = () =>
  apiAuth.get("/sedex-sales/statuses") as apiResponseType;

export const updateSedexStatus = (uuid: string, data: UpdateSedexStatusParams) =>
  apiAuth.put(`/sedex-sales/${uuid}/update-status`, data) as apiResponseType;

export const getPrintLabel = (uuid: string) =>
  apiAuth.get(`/sedex-sales/${uuid}/print-label`) as apiResponseType;

export interface CreateManualSedexParams {
  client_id: number;
  unity_id?: string;
  total: number;
  manual_code?: string;
  tracking_code?: string;
  observation?: string;
  address: {
    street: string;
    number?: string;
    complement?: string;
    neighborhood: string;
    city: string;
    state: string;
    zip_code: string;
  };
}

export const createManualSedex = (data: CreateManualSedexParams) =>
  apiAuth.post("/sedex-sales/store-manual", data) as apiResponseType;
